import { render, staticRenderFns } from "./AiScoreView.vue?vue&type=template&id=a65f399e&scoped=true"
import script from "./AiScoreView.vue?vue&type=script&lang=js"
export * from "./AiScoreView.vue?vue&type=script&lang=js"
import style0 from "./AiScoreView.vue?vue&type=style&index=0&id=a65f399e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65f399e",
  null
  
)

export default component.exports